import { clsx } from "clsx";
import { IconButton } from "@rg/ui/components/IconButton";
import { useOnlyFansCreators } from "@/common/hooks/useOnlyFansCreators";
import { useOfModuleImpression } from "@/common/hooks/useOfModuleImpression";
import CloseIcon from "@/common/images/icons/x.svg?react";
import { AdCreator } from "../AdCreator";
import "./OnlyFansCreatorsSidebar.scss";
import LoaderIcon from "./images/fans-loader.svg?react";
import React, { useRef } from "react";

interface IOnlyFansCreatorsSidebar {
  isStuck: boolean;
  onClose: () => void;
}

export const OnlyFansCreatorsSidebar = ({ isStuck, onClose }: IOnlyFansCreatorsSidebar) => {
  const { adCreators, isLoading } = useOnlyFansCreators("sidebar");
  const handleView = useOfModuleImpression("skyscraper");
  const containerRef = useRef<HTMLDivElement | null>(null);

  if (isLoading) {
    return <LoaderIcon />;
  }

  const handleClose = () => {
    containerRef.current?.focus({ preventScroll: true });
    onClose();
  };

  return (
    <div
      className={clsx("OnlyFansCreatorsSidebar", isStuck && "OnlyFansCreatorsSidebarStuck")}
      ref={containerRef}
      tabIndex={-1}
    >
      {isStuck && (
        <IconButton
          className="closeButton"
          variant="tertiary"
          size="xs"
          onClick={handleClose}
          aria-label="Close pinned sidebar"
          icon={<CloseIcon />}
        />
      )}
      <h3 className="title">Onlyfans creators you might enjoy:</h3>
      <div className="list">
        {adCreators.map((adCreator, index) => (
          <React.Fragment key={adCreator.extra.id}>
            <AdCreator
              name={adCreator.extra.name}
              link={adCreator.link}
              image={adCreator.extra.imgUrl}
              socialName="onlyfans"
              handleView={handleView}
            />
            {index < adCreators.length - 1 && <hr />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
